import { vpnManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import axios, { isAxiosError } from "axios";

export const getVPNSupportSessions = async (
  namespace: string,
  otherParams?: {
    [key: string]: string;
  },
) => {
  const url = vpnManagerUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get(
      `${url}/api/v1/ns/${namespace}/support-sessions`,
      {
        headers: headers,
        params: {
          active: true,
          ...otherParams,
        },
      },
    );
    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch support sessions. Please try again later.",
      );
    } else {
      throw new Error(
        "An unexpected error occurred while fetching support sessions.",
      );
    }
  }
};
